import { Amenity } from "@b2bportal/lodging-api";
import { type IconSet, IconNameEnum } from "../context";
import type { HotelsAmenityIconSet } from "../product/hotels";
import AirplaneArrive from "./airplane-arrive.svg?react";
import AirplaneDeparture from "./airplane-departure.svg?react";
import AirplaneDiagonal from "./airplane-diagonal.svg?react";
import Airplane from "./airplane.svg?react";
import ArrowRight from "./arrow-right.svg?react";
import B2BUser from "./b2b-user.svg?react";
import GenericError from "./base/genericError.svg?react";
import Bed from "./bed.svg?react";
import Calendar from "./calendar.svg?react";
import CarouselLeftArrow from "./carousel-left-arrow.svg?react";
import CarouselRightArrow from "./carousel-right-arrow.svg?react";
import Charge from "./Charge.svg?react";
import CheckCircle from "./check-circle.svg?react";
import CheckFilled from "./check-filled.svg?react";
import Check from "./Check.svg?react";
import ChevronDown from "./chevron-down.svg?react";
import ChevronLeft from "./chevron-left.svg?react";
import ChevronUp from "./chevron-up.svg?react";
import ChevronRight from "./Chevron.svg?react";
import Close from "./Close.svg?react";
import Dismiss from "./dismiss.svg?react";
import Document from "./document.svg?react";
import FilledInfo from "./filled-info.svg?react";
import Filters from "./filters.svg?react";
import Generic from "./GenericFareDetail.svg?react";
import Glass from "./glass.svg?react";
import HeartOutline from "./heart-outline.svg?react";
import Hotel from "./hotel.svg?react";

// Price Freeze
// Amenities
import Accessible from "./hotelAmenities/accessible.svg?react";
import AirConditioning from "./hotelAmenities/air_conditioning.svg?react";
import Attractions from "./hotelAmenities/attractions.svg?react";
import Bakery from "./hotelAmenities/bakery.svg?react";
import Bar from "./hotelAmenities/bar.svg?react";
import Bathroom from "./hotelAmenities/bathroom.svg?react";
import BellServices from "./hotelAmenities/bell.svg?react";
import Casino from "./hotelAmenities/casino.svg?react";
import Fallback from "./hotelAmenities/checkmark.svg?react";
import CoffeeTeaCafe from "./hotelAmenities/coffee_tea_cafe.svg?react";
import CreditCard from "./hotelAmenities/credit_card.svg?react";
import DryCleaning from "./hotelAmenities/dry_cleaning.svg?react";
import Fitness from "./hotelAmenities/fitness.svg?react";
import FoodDrink from "./hotelAmenities/food_drink.svg?react";
import FunGames from "./hotelAmenities/fun_games.svg?react";
import Guide from "./hotelAmenities/guide.svg?react";
import Kitchen from "./hotelAmenities/kitchen.svg?react";
import Menu from "./hotelAmenities/menu.svg?react";
import OutdoorSeating from "./hotelAmenities/outdoor_seating.svg?react";
import Outdoors from "./hotelAmenities/outdoors.svg?react";
import Parking from "./hotelAmenities/parking.svg?react";
import PetFriendly from "./hotelAmenities/pet_friendly.svg?react";
import Pool from "./hotelAmenities/pool.svg?react";
import Power from "./hotelAmenities/power.svg?react";
import Resort from "./hotelAmenities/resort.svg?react";
import SofaBed from "./hotelAmenities/sofa_bed.svg?react";
import SpaAndWellness from "./hotelAmenities/spa_and_wellness.svg?react";
import Suitcase from "./hotelAmenities/suitcase.svg?react";
import Taxi from "./hotelAmenities/taxi.svg?react";
import Wifi from "./hotelAmenities/wifi.svg?react";
import Info from "./Info.svg?react";
import List from "./list.svg?react";
import MapPin from "./map-pin.svg?react";
import Map from "./map.svg?react";
import Minus from "./minus.svg?react";
import PlusCircle from "./plus-circle.svg?react";
import Plus from "./plus.svg?react";
import PremiumDisruptionAssistanceLogo from "./PremiumDisruptionAssistance.svg?react";
import PriceFreezeCheckMark from "./priceFreeze/check.svg?react";
import PriceFreezeSnowFlake from "./priceFreeze/price-freeze-snow-flake.svg?react";
import PriceFreezePriceGoesDown from "./priceFreeze/price-goes-down.svg?react";
import PriceFreezePriceGoesUp from "./priceFreeze/price-goes-up.svg?react";
import ShieldOutline from "./shield-outline.svg?react";
import StarFilled from "./star-filled.svg?react";
import SupportSendMessage from "./support/send-message.svg?react";
import SupportStarEmpty from "./support/star-rounded-empty.svg?react";
import SupportStarFilled from "./support/star-rounded-filled.svg?react";
import SupportChat from "./support/support-chat.svg?react";
import SupportChevronRight from "./support/support-chevron-right.svg?react";
import SupportPhoneIntl from "./support/support-phone-intl.svg?react";
import SupportPhone from "./support/support-phone.svg?react";
import Tag from "./tag.svg?react";
import TriangleDown from "./triangle-down.svg?react";
import TripadvisorLogo from "./tripadvisor-logo.svg?react";
import Tripadvisor from "./tripadvisor.svg?react";
import Trips from "./trips.svg?react";
import MapPointer from "./ui/map-pointer.svg?react";
import Unavailable from "./Unavailable.svg?react";
import IconCar from "./vehicles/car.svg?react";
import Warning from "./warning.svg?react";
import WarningTriangle from "./warningTriangle.svg?react";
import XCoverLogo from "./xcover.svg?react";

export const defaultHotelAmenities: HotelsAmenityIconSet = {
  [Amenity.Accessibility]: Accessible,
  [Amenity.AccessibleBathroom]: Accessible,
  [Amenity.AirConditioning]: AirConditioning,
  [Amenity.AirportTransportation]: Taxi,
  [Amenity.AirportTransportationAvailableGeneral]: Taxi,
  [Amenity.Bar]: Bar,
  [Amenity.BarbecueGrill]: Kitchen,
  [Amenity.BarOrLounge]: Bar,
  [Amenity.Beach]: Resort,
  [Amenity.CoffeeMaker]: CoffeeTeaCafe,
  [Amenity.CoffeeTea]: CoffeeTeaCafe,
  [Amenity.DryCleaningLaundryService]: DryCleaning,
  [Amenity.FitnessCenter]: Fitness,
  [Amenity.FitnessFacilities]: Fitness,
  [Amenity.FreeAirportTransportation]: Taxi,
  [Amenity.FreeBreakfast]: Bakery,
  [Amenity.FreeSelfParking]: Parking,
  [Amenity.FreeWifi]: Wifi,
  [Amenity.FullServiceSpa]: SpaAndWellness,
  [Amenity.HomeEssentials]: SofaBed,
  [Amenity.HotTub]: Bathroom,
  [Amenity.IndoorPool]: Pool,
  [Amenity.InRoomAccessibility]: Accessible,
  [Amenity.KitchenEssentials]: Kitchen,
  [Amenity.Laundry]: DryCleaning,
  [Amenity.LaundryFacilities]: DryCleaning,
  [Amenity.NumberOfBarsOrLounges]: Bar,
  [Amenity.NumberOfRestaurants]: Menu,
  [Amenity.OutdoorPool]: Pool,
  [Amenity.OutdoorSeasonalPool]: Pool,
  [Amenity.PaidBreakfast]: Bakery,
  [Amenity.PaidSelfParking]: Parking,
  [Amenity.PaidValetParking]: Parking,
  [Amenity.Parking]: Parking,
  [Amenity.ParkingAvailableGeneral]: Parking,
  [Amenity.Pool]: Pool,
  [Amenity.PoolGeneral]: Pool,
  [Amenity.PoolsideBar]: Bar,
  [Amenity.Restaurant]: Menu,
  [Amenity.RollInShower]: Bathroom,
  [Amenity.RoomWifi]: Wifi,
  [Amenity.RoundTheClockCheckIn]: Suitcase,
  [Amenity.SomeAccessibilityFeaturesAvailableGeneral]: Accessible,
  [Amenity.Spa]: SpaAndWellness,
  [Amenity.SpaTreatmentRoom]: SpaAndWellness,
  [Amenity.SteamRoom]: SpaAndWellness,
  [Amenity.SwimmingPool]: Pool,
  [Amenity.TwentyFourHourFitnessFacilities]: Fitness,
  [Amenity.WheelchairAccessibleParking]: Accessible,
  [Amenity.WheelchairAccessiblePathOfTravel]: Accessible,
  [Amenity.Arcade]: FunGames,
  [Amenity.AtmBanking]: CreditCard,
  [Amenity.BeachEssentials]: Resort,
  [Amenity.Casino]: Casino,
  [Amenity.ConciergeServices]: BellServices,
  [Amenity.ElectricCarCharging]: Power,
  [Amenity.ExpressCheckIn]: Suitcase,
  [Amenity.HikingOrBikingNearby]: Outdoors,
  [Amenity.Library]: Guide,
  [Amenity.LuggageStorage]: Suitcase,
  [Amenity.Nightclub]: Bar,
  [Amenity.OutdoorSpace]: OutdoorSeating,
  [Amenity.PetFriendly]: PetFriendly,
  [Amenity.PetsAllowed]: PetFriendly,
  [Amenity.PetsAllowedNoFees]: PetFriendly,
  [Amenity.PetsOnlyCats]: PetFriendly,
  [Amenity.PetsOnlyDogs]: PetFriendly,
  [Amenity.PetsOnlyDogsAndCats]: PetFriendly,
  [Amenity.PorterBellhop]: BellServices,
  [Amenity.Sauna]: SpaAndWellness,
  [Amenity.SnackOrDeli]: FoodDrink,
  [Amenity.Terrace]: OutdoorSeating,
  [Amenity.ToursTicketAssistance]: Attractions,
  [Amenity.WaterPark]: Pool,
  // TODO: These amenities need icons.
  [Amenity.AdultsOnly]: Fallback,
  [Amenity.BrailleOrRaisedSignage]: Fallback,
  [Amenity.BusinessCenter]: Fallback,
  [Amenity.BusinessFacilities]: Fallback,
  [Amenity.Childcare]: Fallback,
  [Amenity.ComputerStation]: Fallback,
  [Amenity.ConferenceSpace]: Fallback,
  [Amenity.Entertainment]: Fallback,
  [Amenity.HairDryer]: Fallback,
  [Amenity.Heating]: Fallback,
  [Amenity.HomeInfo]: Fallback,
  [Amenity.KidFriendly]: Fallback,
  [Amenity.MeetingRooms]: Fallback,
  [Amenity.TwentyFourHourFrontDesk]: Fallback,
  [Amenity.Workspace]: Fallback,
  [Amenity.Garden]: Fallback,
  [Amenity.Golf]: Fallback,
  [Amenity.HairSalon]: Fallback,
  [Amenity.SafeDepositBoxFrontDesk]: Fallback,
  [Amenity.Tennis]: Fallback,
};

export const defaultIcons: IconSet = {
  [IconNameEnum.itinerary]: Document,
  [IconNameEnum.trips]: Trips,
  [IconNameEnum.info]: Info,
  [IconNameEnum.infoFilled]: FilledInfo,
  [IconNameEnum.dropdownTriangle]: TriangleDown,
  [IconNameEnum.dropdownArrow]: ChevronDown,
  [IconNameEnum.backIcon]: ChevronLeft,
  [IconNameEnum.actionIcon]: ChevronRight,
  [IconNameEnum.fareDetailsAvailable]: CheckFilled,
  [IconNameEnum.fareDetailsUnavailable]: Unavailable,
  [IconNameEnum.fareDetailsCharge]: Charge,
  [IconNameEnum.fareDetailsGeneric]: Generic,
  [IconNameEnum.filter]: Filters,
  [IconNameEnum.close]: Close,
  [IconNameEnum.nextIcon]: ChevronRight,
  [IconNameEnum.airplane]: Airplane,
  [IconNameEnum.airplaneDiagonal]: AirplaneDiagonal,
  [IconNameEnum.airplaneArrive]: AirplaneArrive,
  [IconNameEnum.airplaneDeparture]: AirplaneDeparture,
  [IconNameEnum.calendar]: Calendar,
  [IconNameEnum.plus]: Plus,
  [IconNameEnum.plusCircle]: PlusCircle,
  [IconNameEnum.minus]: Minus,
  [IconNameEnum.calendarSeparatorIcon]: ArrowRight,
  [IconNameEnum.mapPin]: MapPin,
  [IconNameEnum.searchForFlights]: Glass,
  [IconNameEnum.passengerSelection]: B2BUser,
  [IconNameEnum.check]: Check,
  [IconNameEnum.checkFilled]: CheckFilled,
  [IconNameEnum.checkCircle]: CheckCircle,
  [IconNameEnum.disruptionExerciseFullyCoveredIcon]: CheckFilled,
  [IconNameEnum.disruptionDeclined]: Warning,
  [IconNameEnum.warning]: Warning,
  [IconNameEnum.chevronUp]: ChevronUp,
  [IconNameEnum.chevronDown]: ChevronDown,
  [IconNameEnum.guest]: B2BUser,
  [IconNameEnum.search]: Glass,
  [IconNameEnum.carouselRightArrow]: CarouselRightArrow,
  [IconNameEnum.carouselLeftArrow]: CarouselLeftArrow,
  [IconNameEnum.tripadvisor]: Tripadvisor,
  [IconNameEnum.starFilled]: StarFilled,
  [IconNameEnum.bed]: Bed,
  [IconNameEnum.premiumDisruptionAssistance]: PremiumDisruptionAssistanceLogo,
  [IconNameEnum.chevronRight]: ChevronRight,
  [IconNameEnum.tripCardLink]: ChevronRight,
  [IconNameEnum.dismiss]: Dismiss,
  [IconNameEnum.hotel]: Hotel,
  [IconNameEnum.rightArrow]: ArrowRight,
  [IconNameEnum.warningTriangle]: WarningTriangle,
  [IconNameEnum.map]: Map,
  [IconNameEnum.list]: List,
  [IconNameEnum.ui__accordionAction]: ChevronDown,
  [IconNameEnum.base__genericError]: GenericError,
  [IconNameEnum.ui__mapMarker]: MapPointer,
  [IconNameEnum.insuranceProtection]: ShieldOutline,
  [IconNameEnum.cancelForAnyReason]: ShieldOutline,
  [IconNameEnum.cfar__shieldInfo]: ShieldOutline,
  [IconNameEnum.xcoverLogo]: XCoverLogo,
  [IconNameEnum.wishlist__heart]: HeartOutline,
  [IconNameEnum.offers__tag]: Tag,
  [IconNameEnum.support__chat]: SupportChat,
  [IconNameEnum.support__chevronRight]: SupportChevronRight,
  [IconNameEnum.support__phone]: SupportPhone,
  [IconNameEnum.support__phoneIntl]: SupportPhoneIntl,
  [IconNameEnum.support__sendMessage]: SupportSendMessage,
  [IconNameEnum.support__starEmpty]: SupportStarEmpty,
  [IconNameEnum.support__starFilled]: SupportStarFilled,
  [IconNameEnum.hotel__breakfast]: Bakery,
  [IconNameEnum.ui__infoPopover]: Info,
  hotelAmenities: defaultHotelAmenities,
};

export const defaultHotelPriceFreezeIcons: IconSet = {
  [IconNameEnum.PriceFreezeSnowFlake]: PriceFreezeSnowFlake,
  [IconNameEnum.PriceFreezePriceGoesUp]: PriceFreezePriceGoesUp,
  [IconNameEnum.PriceFreezePriceGoesDown]: PriceFreezePriceGoesDown,
  [IconNameEnum.PriceFreezeCheckMark]: PriceFreezeCheckMark,
};

export const defaultVehicleIcons: IconSet = {
  [IconNameEnum.car]: IconCar,
};

export { TripadvisorLogo };
